var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "article",
      { staticClass: "box" },
      [
        _c("div", { staticClass: "columns" }, [
          _vm._m(0),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "control is-pulled-right" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary tooltip is-tooltip",
                  attrs: { "data-tooltip": "Add new misc" },
                  on: {
                    click: function ($event) {
                      _vm.isAvailableItemsModuleActive =
                        !_vm.isAvailableItemsModuleActive
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", {
                      staticClass: "mdi",
                      class: {
                        "mdi-plus": !_vm.isAvailableItemsModuleActive,
                        "mdi-close": _vm.isAvailableItemsModuleActive,
                      },
                    }),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.isAvailableItemsModuleActive ? "Close" : "Add")
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
        _vm.isAvailableItemsModuleActive
          ? _c(
              "div",
              [
                _c("quote-template-available-miscs", {
                  attrs: { "labour-type": "FQT" },
                  on: { "item-added": _vm.addNewItem },
                  model: {
                    value: _vm.items,
                    callback: function ($$v) {
                      _vm.items = $$v
                    },
                    expression: "items",
                  },
                }),
                _c("hr"),
              ],
              1
            )
          : _vm._e(),
        _c(
          "bulma-table",
          {
            staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
            attrs: {
              columns: _vm.columns,
              "is-loading": _vm.isTableLoading,
              "page-index": _vm.filter.pageIndex,
              "page-size": _vm.filter.pageSize,
              "sort-column": _vm.filter.sortColumn,
              "sort-order": _vm.filter.sortOrder,
              "total-rows": _vm.totalRows,
              "show-pagination": false,
              draggable: true,
            },
            on: { sort: _vm.sort },
          },
          [
            _c(
              "draggable",
              _vm._b(
                {
                  attrs: { tag: "tbody", handle: ".item-drag-handle" },
                  on: { change: _vm.itemMoved, end: _vm.endMove },
                  model: {
                    value: _vm.items,
                    callback: function ($$v) {
                      _vm.items = $$v
                    },
                    expression: "items",
                  },
                },
                "draggable",
                {
                  chosen: "chosen",
                  ghostClass: "draggable-ghost",
                  dragClass: "draggable-drag",
                },
                false
              ),
              _vm._l(_vm.items, function (item, index) {
                return _c("tr", { key: index }, [
                  _c("td", { staticClass: "has-vertical-middle" }, [
                    _vm._v(_vm._s(item.itemNo)),
                  ]),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: item.itemDesc,
                          expression: "item.itemDesc",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text" },
                      domProps: { value: item.itemDesc },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(item, "itemDesc", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _c("td", { staticClass: "has-vertical-middle" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty p-icon p-curve p-smooth m-0 p-bigger",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.reportOnly,
                              expression: "item.reportOnly",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(item.reportOnly)
                              ? _vm._i(item.reportOnly, null) > -1
                              : item.reportOnly,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = item.reportOnly,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      item,
                                      "reportOnly",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      item,
                                      "reportOnly",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(item, "reportOnly", $$c)
                              }
                            },
                          },
                        }),
                        _c("div", { staticClass: "state p-primary" }, [
                          _c("i", { staticClass: "icon mdi mdi-check" }),
                          _c("label"),
                        ]),
                      ]
                    ),
                  ]),
                  _c(
                    "td",
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-left",
                        attrs: { precision: 2 },
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", _vm._n($$v))
                          },
                          expression: "item.value",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    {
                      staticClass:
                        "has-vertical-middle has-text-centered is-content-width",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "icon-container items-center" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-danger is-small is-inverted mr-1",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteItem(item)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon is-medium" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-delete mdi-24px",
                                }),
                              ]),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-primary is-small is-inverted item-drag-handle",
                            },
                            [
                              _c("span", { staticClass: "icon is-small" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-drag-vertical mdi-24px",
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "content has-text-grey has-text-centered" },
                  [
                    _c("span", { attrs: { icon: "icon is-large" } }, [
                      _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                    ]),
                    _c("p", [_vm._v("Nothing")]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Miscellaneous")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }